// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recommended-product-type-title {
  font-weight: 600;
  font-size: 23px;
  font-family: Roboto;
  line-height: 28px;
  color: #111827;
}
.quick-summary-title {
  font-size: 16px;
  color: #d2042d;
  font-weight: 400;
  font-family: Roboto;
}
.overall-title {
  font-size: 28px;
  font-weight: 600;
  font-family: Roboto;
}
.recommended-product-type-container .ant-list-bordered {
  border: none;
}
.recommended-match-feature {
  font-size: 16px;
  font-weight: 400;
  font-family: Roboto;
  color: #3b3f3d;
}
.top-strength-title {
  font-size: 16px;
  font-weight: 400;
  font-family: Roboto;
  color: #5b5e5d;
}
.recommended-header {
  background: #000000;
  border-radius: 8px 8px 0px 0px;
}
.recommended-header-text {
  font-size: 16px;
  font-weight: 500;
  font-family: Roboto;
  color: #ffffff;
}
.recommended-match-percentage {
  font-size: 16px;
  font-weight: 400;
  font-family: Roboto;
  color: #3b3f3d;
  justify-content: end;
  display: flex;
}
.cancel-products-btn {
  width: 81px;
  height: 48px;
  background-color: #e0e0e0;
  border: none;
}
.cancel-products-btn:hover {
  width: 81px;
  height: 48px;
  background-color: #e0e0e0 !important;
  border: none;
}
.cancel-products-btn-text {
  font-size: 16px;
  font-weight: 500;
  font-family: Roboto;
  color: #000000;
}
.add-campaign-btn {
  width: 164px;
  height: 48px;
  background-color: #d2042d;
  border: none;
  margin-left: 10px;
}
.add-campaign-btn:hover {
  width: 164px;
  height: 48px;
  background-color: #d2042d !important;
  border: none;
  margin-left: 10px;
}
.add-campaign-btn-text {
  font-size: 16px;
  font-weight: 500;
  font-family: Roboto;
  color: #ffffff;
}
.recommended-scrollable {
  height: 300px;
  overflow-y: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/modal/recommended-products/RecommendedProductType.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB","sourcesContent":[".recommended-product-type-title {\n  font-weight: 600;\n  font-size: 23px;\n  font-family: Roboto;\n  line-height: 28px;\n  color: #111827;\n}\n.quick-summary-title {\n  font-size: 16px;\n  color: #d2042d;\n  font-weight: 400;\n  font-family: Roboto;\n}\n.overall-title {\n  font-size: 28px;\n  font-weight: 600;\n  font-family: Roboto;\n}\n.recommended-product-type-container .ant-list-bordered {\n  border: none;\n}\n.recommended-match-feature {\n  font-size: 16px;\n  font-weight: 400;\n  font-family: Roboto;\n  color: #3b3f3d;\n}\n.top-strength-title {\n  font-size: 16px;\n  font-weight: 400;\n  font-family: Roboto;\n  color: #5b5e5d;\n}\n.recommended-header {\n  background: #000000;\n  border-radius: 8px 8px 0px 0px;\n}\n.recommended-header-text {\n  font-size: 16px;\n  font-weight: 500;\n  font-family: Roboto;\n  color: #ffffff;\n}\n.recommended-match-percentage {\n  font-size: 16px;\n  font-weight: 400;\n  font-family: Roboto;\n  color: #3b3f3d;\n  justify-content: end;\n  display: flex;\n}\n.cancel-products-btn {\n  width: 81px;\n  height: 48px;\n  background-color: #e0e0e0;\n  border: none;\n}\n.cancel-products-btn:hover {\n  width: 81px;\n  height: 48px;\n  background-color: #e0e0e0 !important;\n  border: none;\n}\n.cancel-products-btn-text {\n  font-size: 16px;\n  font-weight: 500;\n  font-family: Roboto;\n  color: #000000;\n}\n.add-campaign-btn {\n  width: 164px;\n  height: 48px;\n  background-color: #d2042d;\n  border: none;\n  margin-left: 10px;\n}\n.add-campaign-btn:hover {\n  width: 164px;\n  height: 48px;\n  background-color: #d2042d !important;\n  border: none;\n  margin-left: 10px;\n}\n.add-campaign-btn-text {\n  font-size: 16px;\n  font-weight: 500;\n  font-family: Roboto;\n  color: #ffffff;\n}\n.recommended-scrollable {\n  height: 300px;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
